import {
	transferOut,
	TransferOutParams,
	TransferOutResponse,
} from "@/api/transactions";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export default function useTransferOut(
	options?: MutationOptionsWithoutFn<TransferOutResponse, TransferOutParams>,
) {
	return useMutation({
		mutationFn: transferOut,
		...options,
	});
}
